import { render, staticRenderFns } from "./botEntrance.vue?vue&type=template&id=e0bd158e&scoped=true"
import script from "./botEntrance.vue?vue&type=script&lang=js"
export * from "./botEntrance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0bd158e",
  null
  
)

export default component.exports